import { enumToOptions } from '@app/shared/helpers';
import { StructureOfRatchetMechanism } from '@app/shared/models/contracts/enums/shared-enums';
import { l, translationKeys } from '@locale/setupI18n';

export const getStructureOfRatchetMechanismOptions = () =>
  enumToOptions(StructureOfRatchetMechanism, undefined, true).map((o) => ({
    viewValue: l(o.viewValue as translationKeys),
    value: o.value,
  }));
